import React from 'react';
import PropTypes from 'prop-types';

const NotificationIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 16">
        <path d="M1.795 13.739h2.872a2.334 2.334 0 004.667 0h2.872A1.773 1.773 0 0014 12a1.714 1.714 0 00-1.256-1.652V7.339a5.293 5.293 0 00-1.526-3.722 5.52 5.52 0 00-2.369-1.443 2.286 2.286 0 00.036-.348 1.886 1.886 0 00-3.769 0 2.286 2.286 0 00.036.348 5.52 5.52 0 00-2.369 1.443 5.293 5.293 0 00-1.526 3.722v3.009A1.745 1.745 0 000 12a1.773 1.773 0 001.795 1.739zM7 14.957a1.23 1.23 0 01-1.256-1.217h2.513A1.23 1.23 0 017 14.957zM7 1.043a.792.792 0 01.808.783.288.288 0 01-.018.122c-.126-.017-.233-.017-.359-.035h-.862a2.278 2.278 0 00-.359.035c0-.035-.018-.087-.018-.122A.792.792 0 017 1.043zm-4.667 6.3A4.327 4.327 0 013.554 4.33a4.605 4.605 0 013.285-1.374h.305a4.605 4.605 0 013.284 1.374 4.3 4.3 0 011.221 3.009v2.922H2.333zM1.795 11.3h10.41a.7.7 0 110 1.391H1.795a.7.7 0 110-1.391z" fill={fill} />
    </svg>
);

NotificationIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

NotificationIcon.defaultProps = {
    width: '14',
    height: '16',
    fill: '#4b254e'
};

export default NotificationIcon;
